import Vue from 'vue'
import resultsDatabaseMethods from './database/resultsDatabaseMethods'
import metadataDatabaseMethods from './database/metadataDatabaseMethods'
import answersDatabaseMethods from './database/answersDatabaseMethods'
import quizzesDatabaseMethods from './database/quizzesDatabaseMethods'
import debugDatabaseMethods from './database/debugDatabaseMethods'
import ligeDatabaseMethods from './database/ligeDatabaseMethods'
import grupeDatabaseMethods from './database/grupeDatabaseMethods'
// DO NOT IMPORT EVENT BUS HERE, prevent circular

const database = {
    results: resultsDatabaseMethods,
    metadata: metadataDatabaseMethods,
    answers: answersDatabaseMethods,
    quizzes: quizzesDatabaseMethods,

    lige: ligeDatabaseMethods,
    grupe: grupeDatabaseMethods,

    debug: debugDatabaseMethods
}

database.install = function () {
    Object.defineProperty(Vue.prototype, '$db', {
        get () { return database }
    })
}

export default database
